import { selectEscalationUiState } from '@app/escalation/state/escalation.selectors';
import { createSelector } from '@ngrx/store';

export const getUiLoading = createSelector(selectEscalationUiState, (state) => state.loading);
